import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rd-overflow-y-auto rd-max-h-[34.375rem] rd-w-full" }

import { useRenderStore } from "@/builder/stores/renderStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'PromptComponent',
  setup(__props) {

const renderStore = useRenderStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["prompt-container", !_unref(renderStore).builderMode ? 'rd-p-8 md:rd-p-16' : 'rd-p-5'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "controls"),
      _renderSlot(_ctx.$slots, "children"),
      _renderSlot(_ctx.$slots, "content")
    ])
  ], 2))
}
}

})